export const SEARCH_RESULTS_CONTAINER_ID = 'SearchSuggestionsAndResults';

/**
 * Simple POI category to translation key mapping for accessibility labels.
 * Subcategories are checked first (exact match), then fallback to parent category.
 */
export const categoryMapping = {
  // Subcategory mappings (checked first for exact matches)
  'eat.bar': 'ui:Bar',
  'eat.coffee': 'ui:Coffee',
  'eat.vending': 'ui:Vending Machine',
  'services.atm': 'ui:ATM',
  'services.currencyexchange': 'ui:Currency Exchange',
  'services.firstaid': 'ui:First Aid',
  'services.mothersroom': 'ui:Nursing Room',
  'services.animalreliefarea': 'ui:Pet Relief Area',
  'services.rentalcar': 'ui:Car Rental',
  'restroom.male': "ui:Men's Restroom",
  'restroom.female': "ui:Women's Restroom",
  'restroom.family': 'ui:Family Restroom',
  'restroom.accessible': 'ui:Accessible Restroom',
  'security.checkpoint': 'ui:Security Checkpoint',
  'security.customs': 'ui:Customs',
  'security.passportcontrol': 'ui:Passport Control',
  'portal.elevator': 'ui:Elevator',
  'portal.escalator': 'ui:Escalator',
  'portal.stairs': 'ui:Stairs',
  'baggage.claim': 'ui:Baggage Claim',
  'baggage.drop': 'ui:Baggage Drop',
  'gate.arrival': 'ui:Arrival Gate',
  'gate.departures': 'ui:Departure Gate',
  'parking.accessible': 'ui:Accessible Parking',
  'parking.ev': 'ui:EV Parking',
  'parking.stall': 'ui:Parking Stall',
  'portal.bus': 'ui:Bus',
  'portal.movingwalkway': 'ui:Moving Walkway',
  'portal.ramp': 'ui:Ramp',
  'portal.train': 'ui:Train',
  'relax.chair': 'ui:Chair',
  'relax.childrensplayarea': 'ui:Play Area',
  'relax.lounge': 'ui:Lounge',
  'relax.observationdeck': 'ui:Observation Deck',
  'relax.photobooth': 'ui:Photo Booth',
  'relax.prayerroom': 'ui:Prayer Room',
  'relax.seating': 'ui:Seating',
  'relax.showers': 'ui:Showers',
  'relax.tv': 'ui:TV',

  // Parent category mappings (fallback)
  art: 'ui:Art',
  baggage: 'ui:Baggage',
  checkin: 'ui:Check-in',
  eat: 'ui:Restaurant',
  'element.door': 'ui:Door',
  equipment: 'ui:Equipment',
  gate: 'ui:Gate',
  hotel: 'ui:Hotel',
  meeting: 'ui:Meeting Room',
  office: 'ui:Office',
  parking: 'ui:Parking',
  portal: 'ui:Access Point',
  recreation: 'ui:Recreation',
  relax: 'ui:Lounge',
  restroom: 'ui:Restroom',
  room: 'ui:Room',
  security: 'ui:Security',
  services: 'ui:Services',
  shop: 'ui:Shop',
  ticketing: 'ui:Ticketing',
  transport: 'ui:Transportation',
  workstation: 'ui:Workstation',
};
